var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"margin":"0 1rem"},attrs:{"height":_vm.height,"width":_vm.width}},[_c('use',{attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xlink:href":_vm.iconId}})])}
var staticRenderFns = []

export { render, staticRenderFns }